import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const DailyInspirationListScreen = lazy(() => import('../../screens/DailyInspiration/screens/List'));
const DailyInspirationViewScreen = lazy(() => import('../../screens/DailyInspiration/screens/View'));
const DailyInspirationCreateScreen = lazy(() => import('../../screens/DailyInspiration/screens/Create'));
const DailyInspirationEditScreen = lazy(() => import('../../screens/DailyInspiration/screens/Edit'));

const dailyInspirationRoutes = [
    <Route
        exact
        key={routes.DAILY_INSPIRATION_LIST}
        path={routes.DAILY_INSPIRATION_LIST}
        render={() => (
            <Authenticated>
                <DailyInspirationListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DAILY_INSPIRATION_VIEW}
        path={routes.DAILY_INSPIRATION_VIEW}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DailyInspirationViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DAILY_INSPIRATION_CREATE}
        path={routes.DAILY_INSPIRATION_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DailyInspirationCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DAILY_INSPIRATION_EDIT}
        path={routes.DAILY_INSPIRATION_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DailyInspirationEditScreen />
            </Authenticated>
        )}
    />,
];

export default dailyInspirationRoutes;
